import React, { Component } from 'react';

import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { ProminentValue } from 'web-ui-components/lib/typography/values';
import { Inline } from 'web-ui-components/lib/layout/grids';
import FraudAndDisputeStore from '../../../stores/FraudAndDisputeStore';

class ThresholdMessage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { content, messageContent, onConfirm } = this.props;

    const disputeType = FraudAndDisputeStore.getDisputeJourneyType();
    const { details } =
      messageContent?.[disputeType.toUpperCase()] ?? messageContent;

    return (
      <ApplicationFormShell>
        <Inline.Centered
          nodes={[
            <img
              alt="leaning on a clock"
              src="../../../../images/bow/leaning-on-clock.svg"
            />,
          ]}
        />
        <div className="text-center">
          <Inline.Centered
            nodes={[<PageHeading>{messageContent.title}</PageHeading>]}
          />
          <StandardBody>
            <p>
              <ProminentValue>{details}</ProminentValue>
            </p>
          </StandardBody>
        </div>
        <Inline.Centered
          nodes={[
            <NavigationButton.Primary
              data-test-id="return-to-dashboard-button"
              labelText={content.okGotItButtonLabel}
              onClick={onConfirm}
            />,
          ]}
        />
      </ApplicationFormShell>
    );
  }
}

export const MinimumThreshold = (props) => (
  <ThresholdMessage
    {...props}
    messageContent={props.content.DISPUTE.THRESHOLD_MESSAGE.MINIMUM}
  />
);

export const MaximumThreshold = (props) => (
  <ThresholdMessage
    {...props}
    messageContent={props.content.DISPUTE.THRESHOLD_MESSAGE.MAXIMUM}
  />
);
